import { apiPost } from './index'

// 获取活动列表
const wechatShare = (params) => apiPost(`/api/wechat/share/config`, params)

export {
  wechatShare
}



// WEBPACK FOOTER //
// ./src/api/wxshare.js